import { render, staticRenderFns } from "./ReactivateConfirmation.vue?vue&type=template&id=2e3bcaa0&"
import script from "./ReactivateConfirmation.vue?vue&type=script&lang=js&"
export * from "./ReactivateConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports